export const videos = [
  {
    id: 'drama-01',
    title: '海岸线的拥抱',
    category: 'drama',
    year: 2024,
    duration: '96分钟',
    uploadDate: '2024-06-18',
    plays: 128400,
    rating: 9.2,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20two%20young%20men%20standing%20by%20the%20seaside%20at%20sunset%20embracing%20gently%2C%20emotional%20arthouse%20movie%20aesthetic%2C%20warm%20golden%20light%2C%20shallow%20depth%20of%20field%2C%20muted%20color%20grade&width=800&height=450&seq=gv-drama-01&orientation=landscape',
    description:
      '一位在海岸小镇长大的摄影师与多年未见的好友重逢，两人在潮汐起落之间重新找回被时间掩埋的情感。影片以温柔克制的镜头语言，讲述关于告别与勇气的故事。',
    tags: ['重逢', '海边', '成长'],
    featured: true,
    hero: 'https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20two%20young%20men%20walking%20along%20a%20coastal%20road%20at%20golden%20hour%2C%20sweeping%20ocean%20horizon%2C%20warm%20cinematic%20color%20grade%2C%20arthouse%20film%20scene&width=1600&height=900&seq=gv-hero-01&orientation=landscape',
  },
  {
    id: 'drama-02',
    title: '城市微光',
    category: 'drama',
    year: 2023,
    duration: '88分钟',
    uploadDate: '2023-11-02',
    plays: 96200,
    rating: 8.8,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20night%20city%20street%20two%20young%20men%20walking%20together%20under%20neon%2C%20rainy%20pavement%20reflections%2C%20moody%20blue%20evening%20light%2C%20arthouse%20film%20aesthetic&width=800&height=450&seq=gv-drama-02&orientation=landscape',
    description:
      '深夜的城市里，两名在便利店打工的青年因为一场突如其来的大雨而相遇。他们在霓虹与雨水中分享彼此的秘密，也第一次认真面对自己想要的生活。',
    tags: ['都市', '夜归', '治愈'],
    featured: true,
    hero: 'https://readdy.ai/api/search-image?query=cinematic%20wide%20night%20city%20skyline%20with%20two%20silhouettes%20on%20a%20rooftop%2C%20glowing%20city%20lights%2C%20moody%20blue%20tones%2C%20film%20scene&width=1600&height=900&seq=gv-hero-02&orientation=landscape',
  },
  {
    id: 'drama-03',
    title: '雨季告白',
    category: 'drama',
    year: 2024,
    duration: '104分钟',
    uploadDate: '2024-07-21',
    plays: 87600,
    rating: 9.0,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20light%20rain%20two%20young%20men%20sharing%20an%20umbrella%20on%20a%20quiet%20bridge%2C%20soft%20overcast%20light%2C%20emotional%20arthouse%20film%20still%2C%20muted%20green%20tones&width=800&height=450&seq=gv-drama-03&orientation=landscape',
    description:
      '高中时代的好友在毕业前的雨季做出人生抉择。一把伞、一段并肩走过的路，藏着始终没能说出口的那句话。影片细腻描绘青春期最隐秘的心动。',
    tags: ['青春', '暗恋', '毕业'],
  },
  {
    id: 'drama-04',
    title: '旧信笺',
    category: 'drama',
    year: 2022,
    duration: '92分钟',
    uploadDate: '2022-09-14',
    plays: 63200,
    rating: 8.6,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20still%20of%20two%20men%20reading%20old%20letters%20at%20a%20wooden%20desk%20by%20the%20window%2C%20warm%20afternoon%20sunlight%2C%20nostalgic%20film%20aesthetic%2C%20dust%20motes%20in%20air&width=800&height=450&seq=gv-drama-04&orientation=landscape',
    description:
      '整理父亲遗物时，一位年轻人发现了一叠从未寄出的信。随着信件被一封封打开，一段被时代遮蔽的往事与深情缓缓浮现。',
    tags: ['年代', '书信', '记忆'],
  },
  {
    id: 'drama-05',
    title: '天台上的夏天',
    category: 'drama',
    year: 2023,
    duration: '85分钟',
    uploadDate: '2023-08-05',
    plays: 74800,
    rating: 8.5,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20rooftop%20scene%20two%20young%20men%20sitting%20on%20a%20rooftop%20at%20golden%20hour%20above%20the%20city%2C%20warm%20nostalgic%20summer%20light%2C%20arthouse%20film%20still&width=800&height=450&seq=gv-drama-05&orientation=landscape',
    description:
      '高考结束后的那个夏天，两个少年把天台当作秘密基地。他们在这里弹吉他、看星星，也在这里第一次谈论未来与喜欢。',
    tags: ['夏日', '少年', '初恋'],
    featured: true,
    hero: 'https://readdy.ai/api/search-image?query=cinematic%20wide%20summer%20meadow%20two%20figures%20running%20under%20warm%20sun%2C%20lens%20flare%2C%20nostalgic%20film%20scene&width=1600&height=900&seq=gv-hero-03&orientation=landscape',
  },
  {
    id: 'drama-06',
    title: '未寄出的情书',
    category: 'drama',
    year: 2024,
    duration: '78分钟',
    uploadDate: '2024-03-30',
    plays: 54100,
    rating: 8.4,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20still%20of%20a%20young%20man%20writing%20a%20letter%20at%20night%20under%20a%20desk%20lamp%2C%20intimate%20warm%20light%2C%20reflective%20mood%2C%20arthouse%20film%20aesthetic&width=800&height=450&seq=gv-drama-06&orientation=landscape',
    description:
      '一位作家在搬家时翻出十年前写下的情书草稿，收信人正是当年不告而别的他。借着一次意外的重逢，未寄出的信终于有了归宿。',
    tags: ['文艺', '书信', '重逢'],
  },
  {
    id: 'drama-07',
    title: '玻璃之城',
    category: 'drama',
    year: 2021,
    duration: '110分钟',
    uploadDate: '2021-12-01',
    plays: 47900,
    rating: 8.3,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20city%20of%20glass%20modern%20architecture%20two%20men%20in%20a%20vast%20atrium%2C%20cool%20reflective%20light%2C%20moody%20arthouse%20film%20still&width=800&height=450&seq=gv-drama-07&orientation=landscape',
    description:
      '在摩天楼林立的都市里，两个身份悬殊的男人因一场并购案对立，又在深夜的加班中读懂了彼此。关于野心、孤独与选择的故事。',
    tags: ['都市', '职场', '抉择'],
  },
  {
    id: 'drama-08',
    title: '重逢在冬至',
    category: 'drama',
    year: 2023,
    duration: '94分钟',
    uploadDate: '2023-12-22',
    plays: 69200,
    rating: 8.7,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20winter%20scene%20two%20men%20reuniting%20outside%20a%20snowy%20station%2C%20breath%20visible%20in%20cold%20air%2C%20soft%20warm%20station%20lights%2C%20emotional%20film%20still&width=800&height=450&seq=gv-drama-08&orientation=landscape',
    description:
      '分别八年后，两人在同一座北方小城的冬至夜重逢。一碗热汤、一段旧路，曾经错过的时光能否重新开始？',
    tags: ['重逢', '冬日', '温情'],
  },
  {
    id: 'drama-09',
    title: '蓝色房间',
    category: 'drama',
    year: 2024,
    duration: '83分钟',
    uploadDate: '2024-02-14',
    plays: 58400,
    rating: 8.6,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20blue%20toned%20room%20two%20men%20in%20a%20quiet%20conversation%20by%20a%20large%20window%2C%20cool%20blue%20light%2C%20intimate%20arthouse%20film%20aesthetic&width=800&height=450&seq=gv-drama-09&orientation=landscape',
    description:
      '一间刷成蓝色的画室里，画家与他的模特通过一幅未完成的肖像，慢慢走进彼此的内心世界。',
    tags: ['艺术', '对话', '细腻'],
  },
  {
    id: 'drama-10',
    title: '远方的灯塔',
    category: 'drama',
    year: 2022,
    duration: '99分钟',
    uploadDate: '2022-05-09',
    plays: 41300,
    rating: 8.2,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20lighthouse%20on%20a%20distant%20coast%20at%20dusk%2C%20single%20figure%20looking%20out%20to%20sea%2C%20moody%20ocean%20tones%2C%20arthouse%20film%20still&width=800&height=450&seq=gv-drama-10&orientation=landscape',
    description:
      '守塔人与一位独自旅行的青年度过了一个没有游客的淡季。灯塔照亮的不仅是海面，还有两个人都想逃避的过去。',
    tags: ['海岛', '孤旅', '治愈'],
  },
  {
    id: 'short-01',
    title: '三分钟地铁',
    category: 'short',
    year: 2024,
    duration: '8分钟',
    uploadDate: '2024-05-20',
    plays: 152300,
    rating: 8.9,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20subway%20train%20interior%20two%20young%20men%20sitting%20across%20each%20other%20in%20soft%20daylight%2C%20candid%20documentary%20feel%2C%20warm%20muted%20tones%2C%20film%20still&width=800&height=450&seq=gv-short-01&orientation=landscape',
    description:
      '一趟只有三分钟的地铁车厢里，两个陌生人的目光偶然相遇。全片没有一句台词，却道尽了都市里悄然发生的欣赏与告别。',
    tags: ['都市', '无对白', '偶遇'],
    featured: true,
  },
  {
    id: 'short-02',
    title: '隔壁的琴声',
    category: 'short',
    year: 2023,
    duration: '12分钟',
    uploadDate: '2023-07-11',
    plays: 98400,
    rating: 8.5,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20apartment%20wall%20with%20piano%2C%20warm%20lamp%20light%2C%20intimate%20minimalist%20interior%2C%20arthouse%20short%20film%20still%2C%20two%20men%20soft%20focus&width=800&height=450&seq=gv-short-02&orientation=landscape',
    description:
      '每天傍晚，隔壁传来的钢琴声成了他下班后唯一的期待。直到有一天，琴声停了，他决定敲开那扇门。',
    tags: ['音乐', '邻里', '心动'],
  },
  {
    id: 'short-03',
    title: '夏夜短讯',
    category: 'short',
    year: 2024,
    duration: '10分钟',
    uploadDate: '2024-08-02',
    plays: 87500,
    rating: 8.4,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20summer%20night%20two%20young%20men%20on%20a%20balcony%20with%20string%20lights%2C%20warm%20bokeh%2C%20nostalgic%20short%20film%20aesthetic&width=800&height=450&seq=gv-short-03&orientation=landscape',
    description:
      '一个闷热的夏夜，一条迟迟没有发出的短讯。两个男孩在阳台的两端，各自练习着要说的话。',
    tags: ['夏夜', '手机', '青春'],
  },
  {
    id: 'short-04',
    title: '同框',
    category: 'short',
    year: 2022,
    duration: '6分钟',
    uploadDate: '2022-10-18',
    plays: 76200,
    rating: 8.1,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20photograph%20within%20a%20frame%2C%20two%20young%20men%20taking%20a%20selfie%20in%20a%20photo%20booth%2C%20warm%20playful%20light%2C%20retro%20film%20still&width=800&height=450&seq=gv-short-04&orientation=landscape',
    description:
      '拍立得相机定格了十二年里每一次合影。短片用一组照片，串起两个人从陌生到相守的漫长旅程。',
    tags: ['照片', '时光', '相守'],
  },
  {
    id: 'short-05',
    title: '影子与光',
    category: 'short',
    year: 2023,
    duration: '9分钟',
    uploadDate: '2023-09-27',
    plays: 69100,
    rating: 8.3,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20silhouette%20shadow%20and%20light%20two%20figures%20against%20a%20bright%20window%2C%20dramatic%20contrast%2C%20arthouse%20short%20film%20still&width=800&height=450&seq=gv-short-05&orientation=landscape',
    description:
      '一位摄影师执着于捕捉恋人身上的光，却发现真正难拍的，是自己不肯承认的阴影。',
    tags: ['摄影', '光影', '自我'],
  },
  {
    id: 'short-06',
    title: '最后一班渡轮',
    category: 'short',
    year: 2024,
    duration: '14分钟',
    uploadDate: '2024-04-15',
    plays: 81300,
    rating: 8.6,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20ferry%20boat%20at%20dusk%20on%20calm%20water%2C%20two%20figures%20at%20the%20railing%2C%20cool%20blue%20evening%20tones%2C%20film%20still&width=800&height=450&seq=gv-short-06&orientation=landscape',
    description:
      '离岛前的最后一班渡轮上，两个即将各奔东西的朋友用一路的沉默，完成了一次郑重的道别。',
    tags: ['离别', '渡轮', '告别'],
  },
  {
    id: 'short-07',
    title: '阳台上的花',
    category: 'short',
    year: 2021,
    duration: '7分钟',
    uploadDate: '2021-06-08',
    plays: 52600,
    rating: 8.0,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20balcony%20with%20potted%20flowers%20morning%20light%2C%20single%20young%20man%20watering%20plants%2C%20soft%20warm%20tones%2C%20arthouse%20short%20film%20still&width=800&height=450&seq=gv-short-07&orientation=landscape',
    description:
      '搬来不久的他每天清晨为阳台的花浇水，而楼下的邻居总会准时抬头。一盆花，成了两个人无声的问候。',
    tags: ['生活', '日常', '温柔'],
  },
  {
    id: 'short-08',
    title: '出租屋的猫',
    category: 'short',
    year: 2023,
    duration: '11分钟',
    uploadDate: '2023-03-19',
    plays: 63800,
    rating: 8.2,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20cozy%20rental%20apartment%20a%20cat%20on%20the%20windowsill%20and%20a%20young%20man%20reading%2C%20warm%20afternoon%20light%2C%20film%20still&width=800&height=450&seq=gv-short-08&orientation=landscape',
    description:
      '两位合租的室友因为一只流浪猫而渐渐熟络起来。在狭窄的出租屋里，他们学会了如何照顾彼此。',
    tags: ['合租', '日常', '治愈'],
  },
  {
    id: 'special-01',
    title: '时代的印记：男同影像三十年',
    category: 'special',
    year: 2024,
    duration: '52分钟',
    uploadDate: '2024-06-01',
    plays: 112400,
    rating: 9.3,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20editorial%20collage%20style%20film%20history%20archive%20aesthetic%2C%20vintage%20film%20reels%20and%20warm%20sepia%20tones%2C%20documentary%20poster%20still&width=800&height=450&seq=gv-special-01&orientation=landscape',
    description:
      '专题梳理三十年来华语男同题材影像的创作脉络，通过创作访谈与经典片段，回顾作品如何记录一代人的情感与表达。',
    tags: ['专题', '历史', '访谈'],
    featured: true,
  },
  {
    id: 'special-02',
    title: '银幕之外：创作者对谈',
    category: 'special',
    year: 2023,
    duration: '45分钟',
    uploadDate: '2023-10-12',
    plays: 68900,
    rating: 8.8,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20interview%20setting%20two%20creators%20talking%20in%20a%20warm%20studio%2C%20soft%20key%20light%2C%20documentary%20aesthetic%2C%20film%20still&width=800&height=450&seq=gv-special-02&orientation=landscape',
    description:
      '两位长期深耕男同题材的创作者坐下来聊创作初衷、拍摄困境与观众反馈，展现作品背后真实而鲜活的思考。',
    tags: ['对谈', '幕后', '创作'],
  },
  {
    id: 'special-03',
    title: '城市骄傲月特辑',
    category: 'special',
    year: 2024,
    duration: '38分钟',
    uploadDate: '2024-06-25',
    plays: 95600,
    rating: 8.9,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20pride%20month%20city%20street%20celebration%20abstract%2C%20rainbow%20light%20bokeh%20at%20night%2C%20joyful%20documentary%20film%20still&width=800&height=450&seq=gv-special-03&orientation=landscape',
    description:
      '记录一年一度城市骄傲月中普通人的笑容与故事，用镜头捕捉属于每个人的自由与归属感。',
    tags: ['特辑', '城市', '记录'],
  },
  {
    id: 'special-04',
    title: '光影中的自我认同',
    category: 'special',
    year: 2022,
    duration: '41分钟',
    uploadDate: '2022-11-23',
    plays: 57200,
    rating: 8.5,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20mirror%20reflection%20of%20a%20young%20man%20in%20soft%20window%20light%2C%20introspective%20mood%2C%20arthouse%20documentary%20still&width=800&height=450&seq=gv-special-04&orientation=landscape',
    description:
      '专题探讨影像作品如何陪伴观众完成自我认同的过程，收录多位观众的真诚来信与观影记忆。',
    tags: ['认同', '观众', '成长'],
  },
  {
    id: 'special-05',
    title: '从文学到影像',
    category: 'special',
    year: 2023,
    duration: '44分钟',
    uploadDate: '2023-04-30',
    plays: 48900,
    rating: 8.4,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20open%20book%20and%20film%20camera%20on%20a%20wooden%20table%2C%20warm%20literary%20atmosphere%2C%20soft%20daylight%2C%20documentary%20still&width=800&height=450&seq=gv-special-05&orientation=landscape',
    description:
      '专题盘点由文学作品改编的男同题材影像，讨论文字转译成画面的得与失，以及改编带来的全新理解。',
    tags: ['文学', '改编', '讨论'],
  },
  {
    id: 'special-06',
    title: '那些打动我们的镜头',
    category: 'special',
    year: 2024,
    duration: '36分钟',
    uploadDate: '2024-09-06',
    plays: 73400,
    rating: 8.7,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20row%20of%20empty%20cinema%20seats%20with%20warm%20projector%20light%2C%20nostalgic%20film%20festival%20aesthetic%2C%20still&width=800&height=450&seq=gv-special-06&orientation=landscape',
    description:
      '精选影迷票选出的动人瞬间，逐帧解读那些沉默对视、擦肩而过与并肩同行的镜头为何令人难忘。',
    tags: ['观众', '盘点', '记忆'],
  },
];